module.exports = __webpack_public_path__ + "img/ring_g_i_0_1@3x.031e3546.png";